export const prepareData = (data) => (Array.isArray(data) ? data.reduce((acc, { id, productId }) => {
  acc[productId] = { id, productId };

  return acc;
}, {}) : []);

export default {
  namespaced: true,

  state: () => ({
    favorites: [],
    favoritesMeta: {
      offset: 0,
      productsMap: {},
      isEnd: false,
      isLoading: false,
      isPrefetched: false,
    },
    favoritesShort: {},
  }),

  getters: {
    isInShortFavorite: (state) => (productId) => productId in state.favoritesShort,
    hasFavorites: (state) => state.favorites.length > 0,
    short: (state) => state.favoritesShort || {},
    favoritesShortCount: (state) => Object.keys(state.favoritesShort).length,
  },

  mutations: {
    setShort(state, products) {
      state.favoritesShort = prepareData(products);
    },
    addShort(state, product) {
      state.favoritesShort[product.productId] = product;
    },
    removeShort(state, productId) {
      const toRemove = state.favoritesShort[productId];

      if (toRemove) {
        delete state.favoritesShort[productId];
      }
    },
    set(state, products) {
      state.favorites = products;
    },
    setMeta(state, meta) {
      state.favoritesMeta = {
        ...state.favoritesMeta,
        ...meta,
      };
    },

  },

  actions: {
    async loadFavoritesShort({ commit }) {
      const result = await this.$apiBFF.loadFavorites();
      commit('setShort', result);
    },

    async addToShortFavorites({ commit }, productId) {
      try {
        commit('addShort', {
          productId,
        });

        const result = await this.$apiBFF.addToFavorites(productId);
        commit('setShort', result);
        return result;
      } catch (e) {
        commit('removeShort', productId);
      }
    },

    async removeFromShortFavorites({ commit, state }, productId) {
      const favoriteProduct = state.favoritesShort[productId];

      if (!favoriteProduct) {
        return;
      }

      try {
        commit('removeShort', favoriteProduct.productId);
        const result = await this.$apiBFF.removeFromFavorites(favoriteProduct.id);

        return result;
      } catch (e) {
        commit('addShort', {
          productId,
        });
      }
    },

    async loadFavorites({ commit, state, dispatch }, { offset = 0, isServer = false } = {}) {
      if (state.favoritesMeta.isEnd || state.favoritesMeta.isLoading) return;
      try {
        commit('setMeta', {
          isLoading: true,
          isPrefetched: isServer || state.favoritesMeta.isPrefetched,
        });

        const productsIds = await dispatch('getFavoritesProductsIds');

        const productsIdsSliced = productsIds.slice(state.favoritesMeta.offset, offset);
        if (!productsIdsSliced.length) {
          commit('setMeta', {
            isLoading: false,
            isEnd: true,
          });
          return;
        }

        let products = await this.$apiBFF.fetchCatalogProductTiles({
          productIds: productsIdsSliced,
          onlyAvailableProducts: false,
        });

        products = products.map((product) => ({
          ...product,
          // заносим skuId, чтобы был выбран размер на странице избранное
          skuId: state.favoritesMeta.productsMap[product.id],
        }));

        commit('set', state.favorites.concat(products));
        commit('setMeta', {
          offset,
          isEnd: offset >= productsIds.length,
        });
      } finally {
        commit('setMeta', { isLoading: false });
      }
    },

    async getFavoritesProductsIds({ state, commit }) {
      if (!Object.keys(state.favoritesMeta.productsMap).length) {
        const favorites = await this.$apiBFF.loadFavorites();
        const productsMap = favorites.reduce((res, { productId, skuId }) => {
          res[productId] = skuId || null;
          return res;
        }, {});
        commit('setMeta', { productsMap });
      }

      return Object.keys(state.favoritesMeta.productsMap);
    },

    async toggle({ dispatch, getters }, productId = '') {
      if (getters.isInShortFavorite(productId)) {
        const result = await dispatch('removeFromShortFavorites', productId);

        return result;
      }

      const result = await dispatch('addToShortFavorites', productId);

      return result;
    },
  },
};
